import axios from "axios";
import cookies from "@/plugins/cookies";

const api = axios.create({
  baseURL: process.env.VUE_APP_LOQUIZ_API_URL,
  headers: {
    "Content-Type": "application/json"
  }
});

api.interceptors.request.use(config => {
  const accessToken = cookies.get("loquiz-creator.accessToken");

  if (accessToken) {
    config.headers.Authorization = `Bearer ${accessToken}`;
  }

  return config;
});

export default api;
